import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { formatDate } from "../../components/utils";
import {
    getPlanAssignments,
    getStep,
    setDataNull2,
} from "../../store/order/slice";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import axios from "axios";
import { site } from "../../api/url_helper";

function ModalAssignment2({ isShow, onHide, factoryCode, rowData, productId }) {
    const toast = useRef(null);
    const dispatch = useDispatch();
    const [teamWorking, setTeamWorking] = useState("");
    const [categoryName, setCategoryName] = useState("");
    const [intendFinishDate, setIntendFinishDate] = useState("");

    const { stepData, orderData, assignmentsData } = useSelector(
        (state) => ({
            stepData: state.Production.stepData,
            orderData: state.Production.orderData,
            assignmentsData: state.Production.assignmentsData,
        }),
        shallowEqual
    );

    useEffect(() => {
        if (rowData?.id)
            dispatch(
                getPlanAssignments({
                    productId: rowData?.id,
                })
            );
    }, [rowData?.id]);

    useEffect(() => {
        if (isShow && factoryCode) {
            dispatch(getStep({ page: 1, limit: 100, factoryCode }));
        }
    }, [dispatch, isShow, factoryCode]);

    useEffect(() => {
        if (isShow && factoryCode) {
            axios
                .get(
                    `${site}/api/products?page=1&limit=10&factoryCode=${factoryCode}&status=T%E1%BA%A5t+c%E1%BA%A3&current=plan`
                )
                .then((response) => {
                    if (response?.data?.success) {
                        const productData =
                            response?.data?.data?.products?.items;
                        if (productData.length > 0) {
                            setCategoryName(productData[0].categoryName);
                            setIntendFinishDate(
                                productData[0].intendFinishDate
                            );
                            setTeamWorking(productData[0].teamWorking);
                        }
                    } else {
                        console.log(response.data.message);
                    }
                })
                .catch((error) => {
                    alert("Sever đang có vẫn đề, vui lòng thử lại sau");
                })
                .finally(() => {
                    console.log();
                });
        }
    }, [isShow, factoryCode]);

    //   useEffect(() => {
    //     if(isShow)
    //     dispatch(
    //       getDataAll({
    //         page: 1,
    //         limit: 100,
    //       })
    //     );
    //   }, [dispatch,isShow]);
    function calculateTotalDays(assignmentsData) {
        // Sử dụng phương thức reduce để tính tổng dayQuantity
        const totalDays = assignmentsData?.reduce((sum, assignment) => {
            return sum + (assignment.dayQuantity || 0); // Kiểm tra nếu dayQuantity không có giá trị, sẽ tính là 0
        }, 0);

        return totalDays;
    }
    return (
        <Dialog
            header="Phân công sản xuất"
            visible={isShow}
            style={{ width: "60vw" }}
            className="responsive-dialog"
            onHide={() => {
                onHide();
                dispatch(setDataNull2());
            }}
        >
            <Toast ref={toast} />
            <div className="flex justify-content-between pb-2">
                <div>
                    Hạng mục : <span className="font-bold">{categoryName}</span>
                </div>
                <div>
                    Kế hoạch hoàn thành :
                    <span className="font-bold">
                        {formatDate(intendFinishDate)}
                    </span>
                </div>
            </div>
            <div className="flex justify-content-between pb-2">
                <div>
                    Ngày ra BOM :{" "}
                    <span className="font-bold">
                        {formatDate(rowData?.bomProductionDate)}
                    </span>
                </div>
                <div>
                    Tổng số ngày hoàn thành :
                    <span className="font-bold">
                        {calculateTotalDays(assignmentsData)}
                    </span>
                </div>
            </div>
            <DataTable
                emptyMessage="Không có dữ liệu"
                value={assignmentsData || []}
                tableStyle={{ minWidth: "40rem" }}
            >
                <Column
                    field="teamName"
                    header="Nhóm"
                    body={(rowData) => {
                        return <span>{rowData?.TeamGroup?.name}</span>;
                    }}
                    style={{ width: "30%", height: "40px" }}
                ></Column>
                {/* <Column
                    field="classify"
                    header="Phân loại"
                    body={(rowData) => {
                        return <span>{(rowData.classify || 0) * 100}%</span>;
                    }}
                ></Column>
                <Column
                    field="dayQuantity"
                    header="Số ngày"
                    align={"center"}
                ></Column> */}
                <Column
                    field="startDate"
                    header="Từ ngày"
                    alignHeader={"center"}
                    body={(rowData) => formatDate(rowData.startDate)}
                    align={"center"}
                ></Column>
                <Column
                    field="endDate"
                    header="Đến ngày"
                    alignHeader={"center"}
                    body={(rowData) => formatDate(rowData.endDate)}
                    align={"center"}
                ></Column>
                <Column
                    field="latestProductionDate"
                    header="Ngày định vị thực tế"
                    alignHeader={"center"}
                    body={(rowData) => formatDate(rowData.latestProductionDate)}
                    align={"center"}
                ></Column>
                <Column
                    field="status"
                    header="Cảnh báo"
                    alignHeader={"center"}
                    align={"center"}
                    style={{ width: "20%", height: "40px" }}
                ></Column>
                <Column
                    field="note"
                    header="Ghi chú"
                    style={{ width: "20%", height: "40px" }}
                    alignHeader={"center"}
                    align={"center"}
                ></Column>
                {/* <Column
                    field="action"
                    body={actionBodyTemplate}
                    style={{ height: "40px" }}
                /> */}
            </DataTable>
        </Dialog>
    );
}

export default ModalAssignment2;
